module.exports = __webpack_public_path__ + "static/icon-accounting-cde509006d58a5913a4036197f283e17.svg";